import React, { useEffect, useRef, useState } from 'react';
import { Header, Input } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import KanbanMain from './KanbanMain';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { useStore } from '../../app/stores/store';
import { useNavigate, useParams } from 'react-router-dom';
import { TemplateSubTasks, WorkFlowTask } from '../../app/models/template';
import agent from '../../app/api/agent';
import UnauthorizedMessage from '../UnauthorizedMessage';
import { Task, activeOrderType } from '../../app/api/types';

const intialArray = {
  columns: [
    {
      id: 0,
      title: 'Yet To Start',
      cards: [],
    },
    {
      id: 1,
      title: 'Start',
      cards: [],
    },
    {
      id: 2,
      title: 'Complete',
      cards: [],
    },
    {
      id: 3,
      title: 'Hold',
      cards: [],
    },
    {
      id: 4,
      title: 'Resume',
      cards: [],
    },
    {
      id: 5,
      title: 'Reject',
      cards: [],
    },
    {
      id: 6,
      title: 'Resolve',
      cards: [],
    },
    {
      id: 7,
      title: 'Rework',
      cards: [],
    },
  ],
};

function TaskKanban() {
  const params = useParams();
  const {
    ElementStore,
    activityStore,
    KanbanStore,
    mediaAssetStore,
    commonStore,
    dashboardStore,
    viewStore: { getActiveOrder, activeOrder },
  } = useStore();
  const {
    KanbanArray,
    loadingkanbanData,
    Kanban_backend_task_Data,
    KanbanItemId,
    kanbanitemIdAssigner,
    kanbanItemSubtaksId,
    ModelSubtaskInfo,
    ModelTaskInfo,
  } = KanbanStore;

  const {
    getActiveSubtaskInd,
    collectActiveSubTas,
    Kanban_model_Mute_button,
    getTotalCountsOfTask,
    updateElementToggle,
    taskCounts,
  } = ElementStore;
  const { collectMetaData } = activityStore;
  const [searchInputFilter, setSearchInputFilter] = useState('');
  const history = useNavigate();
  const [OnkanbanData, setOnkanbanData] = useState(false);
  const [workflowData, setWorkflowData] = useState<any>([]);
  const [currSubTaskData, setCurrSubTaskData] = useState<any>([]);
  const [completeStatusTrigger, setCompleteStatusTrigger] =
    useState<Boolean>(false);
  const [listTaskItems, setListTaskItems] = useState<Task[]>([]);
  const [taskIndex, setTaskIndex] = useState(0);
  const [subTaskIndex, setSubTaskIndex] = useState(0);
  const [sortedListItems, setSortedListItems] = useState<activeOrderType>();
  const tempListItemsTasks = useRef<WorkFlowTask[]>([]);
  const [element, setElement] = useState<any>({
    intialArray,
  });

  const [redirectPage, setRedirectPage] = useState(false);

  useEffect(() => {
    if (KanbanItemId) {
      collectMetaData(KanbanItemId);
      getActiveOrder({ itemId: KanbanItemId });
    }
    // eslint-disable-next-line
  }, [KanbanItemId]);

  useEffect(() => {
    if (activeOrder.templateId) {
      setListTaskItems(activeOrder?.tasks);
      setSortedListItems(activeOrder);
    }
    // eslint-disable-next-line
  }, [activeOrder]);

  useEffect(() => {
    if (activeOrder?.templateId !== '') {
      if (
        activeOrder?.templateId &&
        mediaAssetStore.mediaAsset.editworkflow === 'edit'
      ) {
        getTotalCountsOfTask(activeOrder.templateId || '');
      }
    }
    // eslint-disable-next-line
  }, [activeOrder?.templateId, mediaAssetStore?.mediaAsset?.editworkflow]);

  useEffect(() => {
    if (mediaAssetStore.mediaAsset.editworkflow === 'edit') {
      tempListItemsTasks.current = JSON.parse(JSON.stringify(listTaskItems));
    }
    // eslint-disable-next-line
  }, [mediaAssetStore.mediaAsset.editworkflow]);

  useEffect(() => {
    if (
      mediaAssetStore.mediaAsset.editworkflow === 'save' &&
      sortedListItems &&
      activityStore.selectedActivity
    ) {
      // let sortedListItemsTemp = Object.assign({}, sortedListItems);
      // sortedListItemsTemp.tasks =
      // sortedListItemsTemp?.tasks = listTaskItems;
      updateElementToggle(
        sortedListItems,
        activityStore.selectedActivity.id,
        taskCounts.totalTaskActiveCount,
        taskCounts.completeTaskActiveCount,
      );
    }
    if (mediaAssetStore.mediaAsset.editworkflow === 'close') {
      getActiveOrder({ itemId: ModelTaskInfo.id });
      setOnkanbanData(false);
    }
    // eslint-disable-next-line
  }, [mediaAssetStore.mediaAsset.editworkflow]);

  useEffect(() => {
    KanbanStore.loadKanbanData();
    setCompleteStatusTrigger(false);
    // eslint-disable-next-line
  }, [completeStatusTrigger]);

  useEffect(() => {
    if (searchInputFilter === '') {
      setElement({
        columns: KanbanArray,
      });
    }
    // eslint-disable-next-line
  }, [KanbanArray]);

  useEffect(() => {
    let arr: any[] = [];

    KanbanArray?.forEach((data: any) => {
      let SearchBoolean = false;
      let newArray: any[] = [];

      data.cards.forEach((itemData: any) => {
        if (
          itemData?.id?.toLowerCase()?.includes(searchInputFilter) !== undefined
        ) {
          (SearchBoolean = itemData?.id
            ?.toLowerCase()
            ?.trim()
            ?.includes(searchInputFilter)) ||
            (SearchBoolean = itemData?.title
              ?.toLowerCase()
              ?.trim()
              ?.includes(searchInputFilter)) ||
            (SearchBoolean = itemData?.description
              ?.toLowerCase()
              ?.trim()
              ?.includes(searchInputFilter));
        } else {
          SearchBoolean = false;
        }

        if (SearchBoolean) {
          newArray.push(itemData);

          arr.push({
            id: data.id,
            title: data.title,
            cards: newArray,
          });
        }
      });
    });
    if (arr?.length === 0 && searchInputFilter.length) {
      setElement(intialArray);
    } else if (arr?.length === 0 || searchInputFilter?.length === 0) {
      setElement({
        columns: KanbanArray,
      });
    } else {
      let uniq = {} as any;
      var arrFiltered = arr.filter(
        (obj) => !uniq[obj.id] && (uniq[obj.id] = true),
      );
      setElement({
        columns: arrFiltered,
      });
    }

    // eslint-disable-next-line
  }, [searchInputFilter]);

  useEffect(() => {
    setCurrSubTaskData(ModelSubtaskInfo);
    // eslint-disable-next-line
  }, [ModelSubtaskInfo]);

  useEffect(() => {
    if (KanbanItemId && workflowData !== undefined) {
      setWorkflowData(Kanban_backend_task_Data);

      let index = 0;
      getActiveSubtaskInd(index);
      // eslint-disable-next-line
      // eslint-disable-next-line
    }
  }, [
    OnkanbanData,
    Kanban_backend_task_Data,
    KanbanItemId,
    getActiveSubtaskInd,
    workflowData,
    ModelSubtaskInfo,
    ModelTaskInfo?.taskId,
    ModelTaskInfo,
  ]);
  useEffect(() => {
    let activitysubtask = Kanban_backend_task_Data?.tasks
      ?.filter(
        (data: TemplateSubTasks) =>
          data.isActive === true && data.isDeleted === false,
      )
      .sort((a: any, b: any) => a.subtaskIndex - b.subtaskIndex);
    collectActiveSubTas(activitysubtask);
    // eslint-disable-next-line
  }, []);

  const CardHandler = (e: any) => {
    const historyItemId = e.currentTarget.getAttribute('data-id');
    kanbanitemIdAssigner(historyItemId);
  };

  const redirectPage1 = (data: any) => {
    kanbanitemIdAssigner(data);
    setRedirectPage(true);
  };
  useEffect(() => {
    if (
      kanbanItemSubtaksId !== undefined &&
      KanbanStore.cardTriggerbtn === true
    ) {
      history(`/mediaAssets/${kanbanItemSubtaksId}`);
    }
    // eslint-disable-next-line
  }, [kanbanItemSubtaksId, redirectPage]);

  useEffect(() => {
    setListTaskItems(Kanban_backend_task_Data.tasks);
    setTaskIndex(ModelTaskInfo?.taskIndex);
    setSubTaskIndex(ModelSubtaskInfo?.subtaskIndex);
    setSortedListItems(Kanban_backend_task_Data);
    // eslint-disable-next-line
  }, [Kanban_backend_task_Data, ModelSubtaskInfo]);
  const closeTaskFormModal = (event: boolean) => {
    setOnkanbanData(event);
  };

  const completeSubtask = async () => {
    const listTaskItemsDup: WorkFlowTask[] = Object.assign([], listTaskItems);
    let taskIndexTemp = taskIndex || 0;
    let subTaskIndexTemp = subTaskIndex || 0;

    let payload = {
      templateId: sortedListItems?.templateId || '',
      // templateId: sortedListItems?.templateId || "",
      itemId: (params as any)?.id,
      taskId: listTaskItemsDup[taskIndexTemp].taskId,
      subtaskId:
        listTaskItemsDup[taskIndexTemp].subTasks[subTaskIndexTemp].subTaskId,
    };
    let p1 = new Promise(async (resolve) => {
      await agent.TaskFormTaskServices.updateCompleteSubTask(payload);
      resolve('');
    });
    p1.then(() => {
      // let message = `Updated ${data.name} "${data.defaultValue}" to "${data.value}" for`;
      // updateHistoryMain("","","","","file upload",metaDataVal?.id,"",false,"",[],[],metaDataVal,message,metaDataVal?.title);
    }).catch((error) => {
      console.error(error);
    });
  };

  const hideSubtask = (data: boolean) => {
    setOnkanbanData(data);
  };
  useEffect(() => {
    Kanban_model_Mute_button(true);
    // eslint-disable-next-line
  }, [Kanban_model_Mute_button, OnkanbanData]);

  // if (loadingkanbanData)
  //   return (
  //     <div style={{ marginTop: '15px' }}>
  //       <LoadingComponent />
  //     </div>
  //   );

  return (
    <>
      {loadingkanbanData && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('KAN01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('KAN01') && !loadingkanbanData && (
        <>
          <div className="kanban_heading">
            <br />
            <Header
              icon="bullseye"
              size="huge"
              dividing
              as="h1"
              content={'Kanban Task List'}
              sub
              color="grey"
            />

            <div className="main-search-search-line">
              <Input
                className="search__line_child"
                icon="search"
                placeholder="Search"
                onChange={(e: any) => {
                  setSearchInputFilter(e.target.value.toLowerCase());
                }}
              />
            </div>

            {!element.columns?.length ? (
              <div></div>
            ) : (
              <KanbanMain
                board={element}
                OnkanbanData={OnkanbanData}
                setOnkanbanData={setOnkanbanData}
                closeTaskFormModal={closeTaskFormModal}
                activeOrder={activeOrder}
                completeSubtask={completeSubtask}
                taskData={Kanban_backend_task_Data}
                taskId={ModelTaskInfo?.taskId}
                hideSubtask={hideSubtask}
                currSubTaskData={currSubTaskData}
                CardHandler={CardHandler}
                redirectPage1={redirectPage1}
              />
            )}
          </div>
        </>
      )}
    </>
  );
}

export default observer(TaskKanban);
